// react
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Modern High-Definition Vector Icons for Mobile Bottom Navigation
 * Replaces legacy 2014 base64 PNGs with clean, crisp SVG line-art
 * that follows Hokky Bangunan's modern brand tone.
 */

// 1. Beranda (Home)
export function NavHomeIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M3 10.5L12 3l9 7.5" />
            <path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" />
        </svg>
    );
}

// 2. Kategori (Categories)
export function NavCategoryIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <rect x="3" y="3" width="7" height="7" rx="2" />
            <rect x="14" y="3" width="7" height="7" rx="2" />
            <rect x="3" y="14" width="7" height="7" rx="2" />
            <rect x="14" y="14" width="7" height="7" rx="2" />
        </svg>
    );
}

// 3. Pesanan / Transaksi (Orders)
export function NavOrdersIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
            <rect x="9" y="3" width="6" height="4" rx="1" />
            <path d="M9 12h6" />
            <path d="M9 16h4" />
        </svg>
    );
}

// 4. Keranjang (Cart)
export function NavCartIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <circle cx="9" cy="21" r="1.5" />
            <circle cx="19" cy="21" r="1.5" />
            <path d="M1 1h4l2.68 12.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
        </svg>
    );
}

// 5. Akun (Account / Profile)
export function NavAccountIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    );
}

// 6. WhatsApp CS
export function NavWhatsappIcon({ size = 22, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
    );
}

NavHomeIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavCategoryIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavOrdersIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavCartIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavAccountIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavWhatsappIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };

// 7. Header Search Icon (Crisp Vector)
export function NavSearchIcon({ size = 20, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.3"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <circle cx="11" cy="11" r="7.5" />
            <line x1="21" y1="21" x2="16.5" y2="16.5" />
        </svg>
    );
}

// 8. Header Cart Icon (Crisp Vector)
export function NavCartHeaderIcon({ size = 20, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <circle cx="9" cy="20.5" r="1.5" fill="currentColor" />
            <circle cx="19" cy="20.5" r="1.5" fill="currentColor" />
            <path d="M1 1.5h3.5l2.4 12.2a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6L22.5 6H5.2" />
        </svg>
    );
}

// 9. Header Wishlist Icon (Crisp Vector)
export function NavWishlistIcon({ size = 20, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
    );
}

NavSearchIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavCartHeaderIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };
NavWishlistIcon.propTypes = { size: PropTypes.number, className: PropTypes.string };

